/**
 * Kickard Phase 3.7.2 — fun guest name generator.
 *
 * Generates Kickard-flavoured names like "RedAce302" / "JokerWolf14"
 * / "GoldenKeeper81". Avoids real-player / club / brand names. Always
 * mobile-safe (≤ 16 chars). Pure local — no network call.
 *
 * Uniqueness is enforced server-side via /api/guest-profile/claim;
 * this helper only produces a candidate.
 */

const ADJECTIVES = [
  'Red', 'Blue', 'Golden', 'Iron', 'Lucky', 'Fast', 'Turbo', 'Quick',
  'Street', 'Storm', 'Cosmic', 'Neon', 'Wild', 'Silent', 'Velvet',
  'Solar', 'Lunar', 'Crimson', 'Shadow', 'Frost', 'Royal', 'Twin',
];

const NOUNS = [
  'Ace', 'Wolf', 'Keeper', 'Striker', 'Fox', 'Panda', 'Falcon', 'Sweeper',
  'Goalie', 'Comet', 'Joker', 'Bullet', 'Rocket', 'Tiger', 'Eagle',
  'Spark', 'Bolt', 'Phoenix', 'Lynx', 'Hawk', 'Raven', 'Pilot',
];

function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

function randomTrailingNumber(): string {
  const len = 1 + Math.floor(Math.random() * 3); // 1–3 digits
  let s = '';
  for (let i = 0; i < len; i++) s += Math.floor(Math.random() * 10).toString();
  return s.replace(/^0+/, '') || String(Math.floor(Math.random() * 9) + 1);
}

const MAX_LEN = 16;

export function generateFunName(): string {
  for (let i = 0; i < 8; i++) {
    const candidate = `${pick(ADJECTIVES)}${pick(NOUNS)}${randomTrailingNumber()}`;
    if (candidate.length <= MAX_LEN) return candidate;
  }
  // Backstop — shorter adjective + noun, 1-digit suffix.
  return `${pick(['Red', 'Blue', 'Fast'])}${pick(['Ace', 'Fox', 'Bolt'])}${Math.floor(Math.random() * 10)}`;
}

export function suggestVariants(base: string): string[] {
  const trimmed = (base || '').trim().replace(/\s+/g, '');
  if (!trimmed) return [generateFunName(), generateFunName(), generateFunName()];
  return [
    `${trimmed}${1 + Math.floor(Math.random() * 99)}`,
    `${trimmed}Ace`,
    `${trimmed}Kick`,
  ].map((s) => s.slice(0, MAX_LEN));
}
